import { Avatar, AVATAR_HEIGHT_24 } from '../../../Avatar'
import { TableCellNumber } from '../../TableCellNumber'
import { TableCellBase } from '../TableCellBase'

import * as styles from './NumberCell.module.css'

import FlatIcon from '../../../../icons/flat.svg'

function NumberCell({
  Icon = FlatIcon,
  unread,
  value,
  valuePrefix = 'Flat.FlatNumberKey',
  ...cellProps
}) {
  return (
    <TableCellBase {...cellProps}>
      <Avatar Icon={Icon} className={styles.avatar} size={AVATAR_HEIGHT_24} />
      <TableCellNumber
        unread={unread}
        value={value}
        valuePrefix={valuePrefix}
      />
    </TableCellBase>
  )
}

export default NumberCell
